import React, {useState} from 'react'
import FormSignup from './FormSignup'
import FormSuccess from './FromSuccess'
import './Form.css'

const Form = () => {
  const [isSubmitted, setIsSubmitted] = useState(false);

  function submitForm () {
    setIsSubmitted(true);
  }

  return (
    <div className='container'>
      {!isSubmitted ? (
        <FormSignup submitForm={submitForm} />
      ) : (
        <FormSuccess />
      )}
    </div>


  )
}

export default Form
